import * as React from "react";
const SvgFiBrandsStoryset = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-storyset_svg__a)">
      <path d="M2.75 8H.07c0-4.43 3.61-8 8-8v2.68c-2.89 0-5.31 2.38-5.31 5.31zM21.25 16h2.68c0 4.43-3.61 8-8 8v-2.68c2.93.04 5.31-2.34 5.31-5.31zM15.74 9.49c-.96-.49-2.49-.96-3.86-1-1.23 0-1.86.45-1.86 1.11 0 .71.89.89 1.97 1.04l1.08.15c2.64.41 4.09 1.56 4.09 3.61 0 2.49-2.05 4.13-5.54 4.13-1.64 0-3.79-.3-5.39-1.41l1.3-2.49c1.04.67 2.3 1.19 4.13 1.19 1.53 0 2.24-.41 2.24-1.15 0-.6-.6-.93-2.01-1.11l-1-.15c-2.79-.37-4.2-1.6-4.2-3.69 0-2.49 1.94-3.94 5.1-3.94 1.94 0 3.46.37 5.06 1.15l-1.09 2.56z" />
    </g>
    <defs>
      <clipPath id="fi-brands-storyset_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsStoryset;
